module.exports = __webpack_public_path__ + "assets/img/1_1700_big.bc93f0df.jpg";